import moment from 'moment';
import React from 'react';
import { View, Image } from 'react-native';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { PodcastProps } from '../../../store/types/soc_svc';
import { getPodImage } from '../helpers/podcasts';

type PodcastCardProps = {
    podcast:PodcastProps,
    width: number,
    onPodcastPress: (podcast:PodcastProps) => void
}
const PodcastCard = ({ podcast, width, onPodcastPress }:PodcastCardProps) => {

    const handlePodcastPress = () => {
        if(!onPodcastPress){ return }
        onPodcastPress(podcast)
    }

    if(width === 0){ return <></> }
    return (
        <TouchableOpacity style={{ margin:5, maxWidth:150, backgroundColor:Colors.shades.white, borderRadius:4 }} onPress={() => handlePodcastPress()}>
            <Image source={getPodImage(podcast)} style={{ height:150, width:150 }} resizeMode='cover' />
            <View style={{ margin:4, padding:5 }}>
                <Text size={14} weight='semibold' color={Colors.shades.black}>{podcast.title}</Text>
                <Text size={12} weight='light' color={Colors.shades.black}>{moment(podcast.last_update_datetime).format('dddd')}</Text>
            </View>
        </TouchableOpacity>
    )
}


const styles = {
    card_style: { margin:8, borderRadius:8, backgroundColor:Colors.shades.white,
        shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 6 }, shadowRadius: 10, shadowOpacity: 1, elevation: 5 },
}

export default PodcastCard